// import React, { useState, useEffect } from 'react';
// import { Download, ChevronLeft, Calendar, Target, FileText } from 'lucide-react';

// export default function OldDietHistory() {
//   const [diets, setDiets] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [patientId] = useState('PNjOY1117p'); // Get from auth/context

//   useEffect(() => {
//     fetchOldDiets();
//   }, [patientId]);

//   const fetchOldDiets = async () => {
//     try {
//       setLoading(true);
//       const response = await fetch(
//         `https://curebay-smart-report-prod-816752733555.asia-south1.run.app/get_old_diet_plans?patientid=${patientId}`
//       );
//       const data = await response.json();
      
//       if (data.status === 'success' && data.data) {
//         // Filter out entries with empty PDF
//         const validDiets = data.data.filter(diet => diet.pdf && diet.pdf.trim() !== '');
//         setDiets(validDiets);
//       } else {
//         setError('Failed to load diet history');
//       }
//     } catch (err) {
//       console.error('Error fetching diet history:', err);
//       setError('Error loading diet history');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownload = (pdf, orderid) => {
//     if (pdf) {
//       const link = document.createElement('a');
//       link.href = pdf;
//       link.download = `Diet_Plan_${orderid}.pdf`;
//       link.target = '_blank';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', { 
//       year: 'numeric', 
//       month: 'short', 
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-4 md:p-8">
//         <div className="max-w-6xl mx-auto">
//           <div className="flex items-center justify-center h-96">
//             <div className="text-center">
//               <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00ACC1] mx-auto mb-4"></div>
//               <p className="text-gray-600">Loading your diet history...</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-4 md:p-8">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="mb-8">
//           <div className="flex items-center gap-3 mb-4">
//             <div className="w-12 h-12 rounded-lg bg-[#00ACC1]/10 flex items-center justify-center">
//               <FileText className="w-6 h-6 text-[#00ACC1]" />
//             </div>
//             <div>
//               <h1 className="text-3xl font-bold text-gray-800">My Diet Plans</h1>
//               <p className="text-gray-600">View and download your previous diet recommendations</p>
//             </div>
//           </div>
//         </div>

//         {/* Error State */}
//         {error && (
//           <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
//             <p className="text-red-800">{error}</p>
//           </div>
//         )}

//         {/* Empty State */}
//         {!loading && diets.length === 0 && (
//           <div className="bg-white rounded-lg shadow-sm p-12 text-center">
//             <FileText className="w-12 h-12 text-gray-300 mx-auto mb-4" />
//             <h3 className="text-lg font-semibold text-gray-800 mb-2">No diet plans yet</h3>
//             <p className="text-gray-600">Your diet plans will appear here once created</p>
//           </div>
//         )}

//         {/* Diet History Table */}
//         {!loading && diets.length > 0 && (
//           <div className="space-y-4">
//             <div className="bg-white rounded-lg shadow-sm overflow-hidden">
//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead className="bg-gray-50 border-b border-gray-200">
//                     <tr>
//                       <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Order ID</th>
//                       <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Health Goals</th>
//                       <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Created Date</th>
//                       <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody className="divide-y divide-gray-200">
//                     {diets.map((diet, idx) => (
//                       <tr key={idx} className="hover:bg-gray-50 transition-colors">
//                         <td className="px-6 py-4">
//                           <code className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-800">
//                             {diet.orderid}
//                           </code>
//                         </td>
//                         <td className="px-6 py-4">
//                           <div className="flex items-start gap-2">
//                             <Target className="w-4 h-4 text-[#00ACC1] mt-1 flex-shrink-0" />
//                             <div>
//                               <p className="text-sm text-gray-800 font-medium">{diet.goal}</p>
//                             </div>
//                           </div>
//                         </td>
//                         <td className="px-6 py-4">
//                           <div className="flex items-center gap-2 text-sm text-gray-600">
//                             <Calendar className="w-4 h-4 text-gray-400" />
//                             {formatDate(diet.createddate)}
//                           </div>
//                         </td>
//                         <td className="px-6 py-4">
//                           {diet.pdf && diet.pdf.trim() !== '' ? (
//                             <button
//                               onClick={() => handleDownload(diet.pdf, diet.orderid)}
//                               className="inline-flex items-center gap-2 px-4 py-2 bg-[#00ACC1] text-white rounded-lg hover:bg-[#0097a7] transition-colors text-sm font-medium"
//                             >
//                               <Download className="w-4 h-4" />
//                               Download
//                             </button>
//                           ) : (
//                             <span className="text-gray-400 text-sm">No PDF</span>
//                           )}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Summary */}
//             <div className="bg-white rounded-lg shadow-sm p-6">
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//                 <div className="text-center">
//                   <div className="text-3xl font-bold text-[#00ACC1]">{diets.length}</div>
//                   <p className="text-gray-600 text-sm mt-2">Total Diet Plans</p>
//                 </div>
//                 <div className="text-center">
//                   <div className="text-3xl font-bold text-green-600">
//                     {diets.filter(d => d.pdf && d.pdf.trim() !== '').length}
//                   </div>
//                   <p className="text-gray-600 text-sm mt-2">PDFs Available</p>
//                 </div>
//                 <div className="text-center">
//                   <div className="text-3xl font-bold text-blue-600">
//                     {diets.length > 0 ? new Date(diets[0].createddate).getFullYear() : '-'}
//                   </div>
//                   <p className="text-gray-600 text-sm mt-2">Latest Year</p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { Download, ChevronLeft, Calendar, Target, FileText, Share2, X, MessageCircle } from 'lucide-react';
import { resolvePdfUrl } from '../../api/Services/resolvePdfUrl';

const WhatsAppShareModal = ({ isOpen, onClose, onConfirm, loading }) => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [error, setError] = useState("");

  const handleShare = () => {
    const phoneRegex = /^[6-9]\d{9}$/;
    
    if (!mobileNumber.trim()) {
      setError("Please enter a mobile number");
      return;
    }

    if (!phoneRegex.test(mobileNumber.trim())) {
      setError("Please enter a valid 10-digit mobile number starting with 6-9");
      return;
    }

    setError("");
    onConfirm(mobileNumber.trim());
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-8 max-w-md w-full">
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-bold text-teal-600 flex items-center gap-2">
            <MessageCircle className="h-6 w-6 text-green-600" />
            Share via WhatsApp
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <X className="h-6 w-6" />
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-4">
          Enter the mobile number where you want to send the diet plan PDF.
        </p>

        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Mobile Number (10 digits)
          </label>
          <input
            type="tel"
            value={mobileNumber}
            onChange={(e) => {
              setMobileNumber(e.target.value.replace(/\D/g, "").slice(0, 10));
              setError("");
            }}
            placeholder="Enter 10-digit number"
            maxLength="10"
            className="w-full px-4 py-2 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-teal-500"
          />
          {error && <p className="text-red-500 text-xs mt-2">{error}</p>}
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="flex-1 px-4 py-2 border-2 border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleShare}
            disabled={loading}
            className="flex-1 px-4 py-2 bg-green-600 text-white rounded-lg font-medium hover:bg-green-700 disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {loading ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Sending...
              </>
            ) : (
              <>
                <MessageCircle className="h-4 w-4" />
                Send
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default function OldDietHistory() {
  const [diets, setDiets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [patientId] = useState('PNjOY1117p');
  const [whatsappModal, setWhatsappModal] = useState(false);
  const [whatsappLoading, setWhatsappLoading] = useState(false);
  const [selectedDiet, setSelectedDiet] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    fetchOldDiets();
  }, [patientId]);

  const fetchOldDiets = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `https://curebay-smart-report-prod-816752733555.asia-south1.run.app/get_old_diet_plans?patientid=${patientId}`
      );
      const data = await response.json();
      
      if (data.status === 'success' && data.data) {
        const validDiets = data.data.filter(diet => diet.pdf && diet.pdf.trim() !== '');
        setDiets(validDiets);
      } else {
        setError('Failed to load diet history');
      }
    } catch (err) {
      console.error('Error fetching diet history:', err);
      setError('Error loading diet history');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (pdf, orderid) => {
    if (!pdf) return;
    const resolvedUrl = await resolvePdfUrl(pdf);
    if (!resolvedUrl) return;
    const link = document.createElement('a');
    link.href = resolvedUrl;
    link.download = `Diet_Plan_${orderid}.pdf`;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShareClick = (diet) => {
    setSelectedDiet(diet);
    setWhatsappModal(true);
  };

  const handleWhatsAppShare = async (mobileNumber) => {
    setWhatsappLoading(true);
    try {
      const resolvedPdfUrl = await resolvePdfUrl(selectedDiet.pdf);
      if (!resolvedPdfUrl) { setToast({ message: "PDF not available", type: "error" }); setWhatsappLoading(false); return; }
      const params = new URLSearchParams({
        patientid: patientId,
        orderid: selectedDiet.orderid,
        pdf_url: resolvedPdfUrl,
        mobile: mobileNumber,
      });

      const response = await fetch(
        `https://curebay-smart-report-prod-816752733555.asia-south1.run.app/get_diet_pdf_whatsapp?${params.toString()}`,
        {
          method: "GET",
        }
      );

      if (response.ok) {
        setToast({ message: "PDF successfully sent to WhatsApp!", type: "success" });
        setWhatsappModal(false);
        setSelectedDiet(null);
      } else {
        const error = await response.json();
        setToast({ message: `Error: ${error.message || "Failed to send PDF"}`, type: "error" });
      }
    } catch (err) {
      setToast({ message: "Error sending PDF. Please try again.", type: "error" });
      console.error("Error sharing to WhatsApp:", err);
    } finally {
      setWhatsappLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-4 md:p-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-center h-96">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00ACC1] mx-auto mb-4"></div>
              <p className="text-gray-600">Loading your diet history...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white p-4 md:p-8">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-[#00ACC1]/10 flex items-center justify-center">
              <FileText className="w-6 h-6 text-[#00ACC1]" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-800">My Diet Plans</h1>
              <p className="text-gray-600">View and download your previous diet recommendations</p>
            </div>
          </div>
        </div>

        {/* Error State */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
            <p className="text-red-800">{error}</p>
          </div>
        )}

        {/* Empty State */}
        {!loading && diets.length === 0 && (
          <div className="bg-white rounded-lg shadow-sm p-12 text-center">
            <FileText className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-800 mb-2">No diet plans yet</h3>
            <p className="text-gray-600">Your diet plans will appear here once created</p>
          </div>
        )}

        {/* Diet History Table */}
        {!loading && diets.length > 0 && (
          <div className="space-y-4">
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50 border-b border-gray-200">
                    <tr>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Order ID</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Health Goals</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Created Date</th>
                      <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {diets.map((diet, idx) => (
                      <tr key={idx} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4">
                          <code className="text-xs bg-gray-100 px-2 py-1 rounded text-gray-800">
                            {diet.orderid}
                          </code>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-start gap-2">
                            <Target className="w-4 h-4 text-[#00ACC1] mt-1 flex-shrink-0" />
                            <div>
                              <p className="text-sm text-gray-800 font-medium">{diet.goal}</p>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center gap-2 text-sm text-gray-600">
                            <Calendar className="w-4 h-4 text-gray-400" />
                            {formatDate(diet.createddate)}
                          </div>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex gap-2">
                            {diet.pdf && diet.pdf.trim() !== '' ? (
                              <>
                                <button
                                  onClick={() => handleDownload(diet.pdf, diet.orderid)}
                                  className="inline-flex items-center gap-2 px-3 py-2 bg-[#00ACC1] text-white rounded-lg hover:bg-[#0097a7] transition-colors text-sm font-medium"
                                >
                                  <Download className="w-4 h-4" />
                                  Download
                                </button>
                                <button
                                  onClick={() => handleShareClick(diet)}
                                  className="inline-flex items-center gap-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
                                >
                                  <Share2 className="w-4 h-4" />
                                  Share
                                </button>
                              </>
                            ) : (
                              <span className="text-gray-400 text-sm">No PDF</span>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Summary */}
            <div className="bg-white rounded-lg shadow-sm p-6">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#00ACC1]">{diets.length}</div>
                  <p className="text-gray-600 text-sm mt-2">Total Diet Plans</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-600">
                    {diets.filter(d => d.pdf && d.pdf.trim() !== '').length}
                  </div>
                  <p className="text-gray-600 text-sm mt-2">PDFs Available</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-blue-600">
                    {diets.length > 0 ? new Date(diets[0].createddate).getFullYear() : '-'}
                  </div>
                  <p className="text-gray-600 text-sm mt-2">Latest Year</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* WhatsApp Share Modal */}
      <WhatsAppShareModal
        isOpen={whatsappModal}
        onClose={() => {
          setWhatsappModal(false);
          setSelectedDiet(null);
        }}
        onConfirm={handleWhatsAppShare}
        loading={whatsappLoading}
      />

      {/* Toast Notification */}
      {toast && (
        <div className={`fixed top-20 right-4 z-50 animate-in fade-in slide-in-from-right-4 duration-300`}>
          <div className={`${
            toast.type === 'success' 
              ? 'bg-gradient-to-r from-green-100 to-emerald-100 border-green-200 text-green-800' 
              : 'bg-gradient-to-r from-red-100 to-rose-100 border-red-200 text-red-800'
          } border-l-4 rounded-lg shadow-lg p-4 max-w-sm flex items-center gap-3`}>
            <span className="text-lg">{toast.type === 'success' ? '✓' : '⚠'}</span>
            <p className="text-sm font-medium flex-1">{toast.message}</p>
            <button
              onClick={() => setToast(null)}
              className="ml-2 opacity-70 hover:opacity-100"
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
}